import * as React from "react";
import Sidebar from "./Sidebar";
import TopNav from "./TopNav";
import { MENU_ITEMS } from "./menuItems";

export default function PageLayout({ 
  activeKey, 
  onLogout, 
  onNavigate,
  children,
  className = ""
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  
  // Load sidebar state from localStorage
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const toggleSidebar = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    // Save to localStorage
    localStorage.setItem('sidebarCollapsed', newState.toString());
  };

  return (
    <div className={`dashboard-root ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar 
        menuItems={MENU_ITEMS} 
        activeKey={activeKey} 
        onNavigate={(item) => {
          onNavigate(item);
          closeMobileMenu();
        }}
        isOpen={mobileMenuOpen}
        onClose={closeMobileMenu}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebar}
        onLogout={onLogout}
      />

      <main className="app-main-content">
        <div className="app-topnav-mobile-wrapper">
          <TopNav
            employeeName="Angelica Santos"
            employeeId="EMP-12345"
            onLogout={onLogout}
            onMenuClick={toggleMobileMenu}
          />
        </div>
        <div className={className}>
          {children}
        </div>
      </main>
    </div>
  );
}
